const dev = {
  API_URL: process.env.API_URL_DEV,
  API_KEY: process.env.API_KEY_DEV,
  FORMDATA_API_URL: process.env.FORMDATA_API_URL_DEV,
  FORMDATA_API_KEY: process.env.FORMDATA_API_KEY_DEV,
  BUCKET: process.env.BUCKET_DEV,
  BUCKET_PDFS: process.env.BUCKET_PDFS_DEV,
  COGNITO_AUTH: {
    userPoolWebClientId: process.env.COGNITO_USER_POOL_WEB_CLIENT_ID_DEV,
    userPoolId: process.env.COGNITO_USER_POOL_ID_DEV,
    region: process.env.COGNITO_REGION_DEV,
    identityPoolId: process.env.COGNITO_IDENTITY_POOL_ID_DEV
  },
  BART_TEMPLATE_ID: Number(process.env.BART_TEMPLATE_ID_DEV),
  GBI_TEMPLATE_ID: Number(process.env.GBI_TEMPLATE_ID_DEV),
  INSPECTION_TEMPLATE_ID: Number(process.env.INSPECTION_TEMPLATE_ID_DEV),
  US_INSPECTION_TEMPLATE_ID: Number(process.env.US_INSPECTION_TEMPLATE_ID_DEV),
  WIND_TEMPLATE_ID: Number(process.env.WIND_TEMPLATE_ID_DEV),
  BI_BART_TEMPLATE_ID: Number(process.env.BI_BART_TEMPLATE_ID_DEV),
  BI_GBI_TEMPLATE_ID: Number(process.env.BI_GBI_TEMPLATE_ID_DEV),
  BI_INSPECTION_TEMPLATE_ID: Number(process.env.BI_INSPECTION_TEMPLATE_ID_DEV),
  BI_US_INSPECTION_TEMPLATE_ID: Number(process.env.BI_US_INSPECTION_TEMPLATE_ID_DEV),
  BI_WIND_TEMPLATE_ID: Number(process.env.BI_WIND_TEMPLATE_ID_DEV),
  US_ADMIN_APP_API_URL: process.env.US_ADMIN_APP_API_URL_DEV
};

const local_dev = {
  ...dev,
  API_URL: process.env.API_URL_LOCAL,
  FORMDATA_API_URL: process.env.FORMDATA_API_URL_LOCAL,
  US_ADMIN_APP_API_URL: process.env.US_ADMIN_APP_API_URL_LOCAL
}

const stage = {
  API_URL: process.env.API_URL_STAGE,
  API_KEY: process.env.API_KEY_STAGE,
  FORMDATA_API_URL: process.env.FORMDATA_API_URL_STAGE,
  FORMDATA_API_KEY: process.env.FORMDATA_API_KEY_STAGE,
  BUCKET: process.env.BUCKET_STAGE,
  BUCKET_PDFS: process.env.BUCKET_PDFS_STAGE,
  COGNITO_AUTH: {
    userPoolWebClientId: process.env.COGNITO_USER_POOL_WEB_CLIENT_ID_STAGE,
    userPoolId: process.env.COGNITO_USER_POOL_ID_STAGE,
    region: process.env.COGNITO_REGION_STAGE,
    identityPoolId: process.env.COGNITO_IDENTITY_POOL_ID_STAGE
  },
  BART_TEMPLATE_ID: Number(process.env.BART_TEMPLATE_ID_STAGE),
  GBI_TEMPLATE_ID: Number(process.env.GBI_TEMPLATE_ID_STAGE),
  INSPECTION_TEMPLATE_ID: Number(process.env.INSPECTION_TEMPLATE_ID_STAGE),
  US_INSPECTION_TEMPLATE_ID: Number(process.env.US_INSPECTION_TEMPLATE_ID_STAGE),
  WIND_TEMPLATE_ID: Number(process.env.WIND_TEMPLATE_ID_STAGE),
  BI_BART_TEMPLATE_ID: Number(process.env.BI_BART_TEMPLATE_ID_STAGE),
  BI_GBI_TEMPLATE_ID: Number(process.env.BI_GBI_TEMPLATE_ID_STAGE),
  BI_INSPECTION_TEMPLATE_ID: Number(process.env.BI_INSPECTION_TEMPLATE_ID_STAGE),
  BI_US_INSPECTION_TEMPLATE_ID: Number(process.env.BI_US_INSPECTION_TEMPLATE_ID_STAGE),
  BI_WIND_TEMPLATE_ID: Number(process.env.BI_WIND_TEMPLATE_ID_STAGE),
  US_ADMIN_APP_API_URL: process.env.US_ADMIN_APP_API_URL_STAGE
};

const prod = {
  API_URL: process.env.API_URL_PROD,
  API_KEY: process.env.API_KEY_PROD,
  FORMDATA_API_URL: process.env.FORMDATA_API_URL_PROD,
  FORMDATA_API_KEY: process.env.FORMDATA_API_KEY_PROD,
  BUCKET: process.env.BUCKET_PROD,
  BUCKET_PDFS: process.env.BUCKET_PDFS_PROD,
  COGNITO_AUTH: {
    userPoolWebClientId: process.env.COGNITO_USER_POOL_WEB_CLIENT_ID_PROD,
    userPoolId: process.env.COGNITO_USER_POOL_ID_PROD,
    region: process.env.COGNITO_REGION_PROD,
    identityPoolId: process.env.COGNITO_IDENTITY_POOL_ID_PROD
  },
  BART_TEMPLATE_ID: Number(process.env.BART_TEMPLATE_ID_PROD),
  GBI_TEMPLATE_ID: Number(process.env.GBI_TEMPLATE_ID_PROD),
  INSPECTION_TEMPLATE_ID: Number(process.env.INSPECTION_TEMPLATE_ID_PROD),
  US_INSPECTION_TEMPLATE_ID: Number(process.env.US_INSPECTION_TEMPLATE_ID_PROD),
  WIND_TEMPLATE_ID: Number(process.env.WIND_TEMPLATE_ID_PROD),
  BI_BART_TEMPLATE_ID: Number(process.env.BI_BART_TEMPLATE_ID_PROD),
  BI_GBI_TEMPLATE_ID: Number(process.env.BI_GBI_TEMPLATE_ID_PROD),
  BI_INSPECTION_TEMPLATE_ID: Number(process.env.BI_INSPECTION_TEMPLATE_ID_PROD),
  BI_US_INSPECTION_TEMPLATE_ID: Number(process.env.BI_US_INSPECTION_TEMPLATE_ID_PROD),
  BI_WIND_TEMPLATE_ID: Number(process.env.BI_WIND_TEMPLATE_ID_PROD),
  US_ADMIN_APP_API_URL: process.env.US_ADMIN_APP_API_URL_PROD
};

let config;
switch (process.env.REACT_APP_STAGE) {
  case "prod":
    config = prod;
    break;
  case "stage":
    config = stage;
    break;
  default:
    if (process.env.REACT_APP_CONFIG_LOCAL === "local") {
      config = local_dev;
    } else {
      config = dev;
    }
}

export default {
  ...config
};
